function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import ActionMenu from './ActionMenu';
import DeConsumerMessage from './DeConsumerMessage';
import Logo from '../Logo/Logo';
import Menu from './Menu';
import React, { useState } from 'react';
import { SkipNav, UsaBanner } from '@cmsgov/design-system';
import { t } from '../i18n';
import classnames from 'classnames';
import defaultMenuLinks from './defaultMenuLinks';
export var VARIATION_NAMES = {
  LOGGED_IN: 'logged-in',
  LOGGED_OUT: 'logged-out'
};

/**
 * For information about how and when to use this component,
 * [refer to its full documentation page](https://design.cms.gov/components/header/healthcare-header/?theme=healthcare).
 */
export var Header = function Header(props) {
  var _props$logoClassName;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    openMenu = _useState2[0],
    setOpenMenu = _useState2[1];
  var isControlledMenu = props.isMenuOpen !== undefined && props.onMenuToggle !== undefined;

  /**
   * Determines which variation of the header should be displayed,
   * based on the props being passed into the component.
   * @returns {String} Variation name
   */
  function variation() {
    if (props.loggedIn) {
      // Logged-in state, with minimal navigation
      return VARIATION_NAMES.LOGGED_IN;
    } else {
      // Logged-out state, either Learn or Product
      return VARIATION_NAMES.LOGGED_OUT;
    }
  }
  function isLoggedIn() {
    return variation() === VARIATION_NAMES.LOGGED_IN;
  }

  /**
   * Content rendered within <Menu>, before the list of links
   * @returns {Node}
   */
  function beforeMenuLinks() {
    if (isLoggedIn() && props.firstName) {
      return /*#__PURE__*/React.createElement("div", {
        className: "ds-u-sm-display--none ds-u-border-bottom--1 ds-u-margin-x--1 ds-u-padding-y--1 hc-c-header__name"
      }, props.firstName);
    }
  }

  /**
   * Event handler for when the "Menu" or "Close" button
   * within ActionMenu is clicked.
   */
  function handleMenuToggleClick() {
    if (!isControlledMenu) {
      setOpenMenu(!openMenu);
    } else {
      props.onMenuToggle();
    }
  }
  var classes = classnames("hc-c-header hc-c-header--".concat(variation()), props.className);
  var hasCustomLinks = !!props.links;
  var defaultLinksForVariation = defaultMenuLinks({
    deConsumer: props.deConsumer,
    subpath: props.subpath,
    primaryDomain: props.primaryDomain,
    switchLocaleLink: props.switchLocaleLink,
    hideLoginLink: props.hideLoginLink,
    hideLogoutLink: props.hideLogoutLink,
    hideLanguageSwitch: props.hideLanguageSwitch,
    customLinksPassedIn: hasCustomLinks
  })[variation()];
  var links = hasCustomLinks ? props.links.concat(defaultLinksForVariation) : defaultLinksForVariation;
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.showUsaBanner && /*#__PURE__*/React.createElement(UsaBanner, {
    id: "hc-c-header__usa-banner"
  }), /*#__PURE__*/React.createElement("header", {
    className: classes,
    role: "banner",
    "aria-label": "global"
  }, /*#__PURE__*/React.createElement(SkipNav, {
    href: props.skipNavHref,
    onClick: props.onSkipNavClick
  }, t('header.skipNav')), /*#__PURE__*/React.createElement("div", {
    className: "ds-l-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ds-l-row ds-u-align-items--center ds-u-flex-wrap--nowrap ds-u-padding-y--2"
  }, /*#__PURE__*/React.createElement("a", {
    href: props.primaryDomain ? props.primaryDomain : '/',
    className: "hc-c-logo-link ds-l-col ds-l-col--auto"
  }, /*#__PURE__*/React.createElement(Logo, {
    className: (_props$logoClassName = props.logoClassName) !== null && _props$logoClassName !== void 0 ? _props$logoClassName : ''
  })), /*#__PURE__*/React.createElement("nav", {
    "aria-label": "Profile, applications, and coverage",
    id: "hc-c-header__actions",
    className: "hc-c-header__actions ds-l-col ds-l-col--auto ds-u-margin-left--auto ds-u-font-weight--bold"
  }, /*#__PURE__*/React.createElement(ActionMenu, {
    t: t,
    firstName: props.firstName,
    onMenuToggleClick: handleMenuToggleClick,
    loggedIn: props.loggedIn,
    open: isControlledMenu ? props.isMenuOpen : openMenu,
    links: links
  }), /*#__PURE__*/React.createElement(Menu, {
    beforeLinks: beforeMenuLinks(),
    links: links,
    open: isControlledMenu ? props.isMenuOpen : openMenu,
    submenuTop: props.submenuTop,
    submenuBottom: props.submenuBottom
  })))), props.deConsumer && /*#__PURE__*/React.createElement(DeConsumerMessage, {
    t: t,
    deBrokerName: props.deBrokerName
  }), props.headerBottom));
};
Header.defaultProps = {
  showUsaBanner: true,
  skipNavHref: '#main'
};
export default Header;